import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import {
  DataObjectCommentDto,
  DataObjectCommentsValidFormDataType,
} from '../schema/types';
import { DataObjectCommentSchema } from '../schema/DataObjectCommentSchema';
import { DataObjectUrl } from './DataObjectUrl';
import { expand } from 'uri-template-lite';

const putDataObjectComments = (
  id: number,
  comments: Partial<DataObjectCommentsValidFormDataType>,
) =>
  apiClient
    .put<
      DataObjectCommentDto[]
    >(expand(DataObjectUrl.COMMENTS, { id }), comments)
    .then((response) => DataObjectCommentSchema.array().parse(response.data));

export const useMutateDataObjectComments = createApiMutationHook(
  ['data-object-comments'],
  getMutationFn(undefined, putDataObjectComments),
);
